import { Injectable } from "@angular/core";
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { AuthenticationService } from "../services";

@Injectable({ providedIn: "root" })
export class AssetGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser.areas.includes("Assets")) {
      return true;
    }

    this.router.navigate([""], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
